import React, { useEffect, useMemo, useRef, useState } from "react";

import { useChainId, useChains } from "wagmi";
import useAuth from "../../hooks/useAuth";
import { Oval, RotatingLines } from "react-loader-spinner";
import {
  selectGeneral,
  setShowNetworkPopup,
} from "../../redux/slices/generalSlice";
import { useDispatch, useSelector } from "react-redux";
import useOutsideClick from "../../hooks/useOutsideClick";
import { MdClose } from "react-icons/md";
import { currencyIcons } from "../../utils/currencies";
import useCheckNetwork from "../../hooks/useCheckNetwork";

const NetworkItem = ({ data, switchNetwork, switchNetworkLoading, currentChainId }) => {
  const { name: title, nativeCurrency, network, id } = data ?? {};
  const isActive = useMemo(() => currentChainId === id, [currentChainId, id]);
  const icon = currencyIcons?.[nativeCurrency?.symbol || "ETH"];
  const [isPending, setIsPending] = useState(false);
  const handleClick = async () => {
    if (isActive) return;
    setIsPending(true);
    const isSwitched = await switchNetwork(network);
    setIsPending(false);
    if (isSwitched) {
      setIsPending(false);
    }
  };
  return (
    <button
      onClick={handleClick}
      className={`w-full font-semibold py-3.5 px-3 flex justify-between items-center rounded-xl relative ${
        isActive
          ? "border border-primary bg-purple-100"
          : "bg-whitesmoke hover:bg-custom-gray-400"
      } `}
    >
      <div className="flex items-center">
        <img src={icon} alt={title} className="h-7 mr-1.5" />

        <span className="text-black">{title}</span>
      </div>
      <div>
        {isPending && switchNetworkLoading ? (
          <RotatingLines
            strokeColor="gray"
            strokeWidth="5"
            animationDuration="0.75"
            width="24"
            visible={true}
          />
        ) : null}
      </div>
    </button>
  );
};
const NetworkPopup = () => {
  const chains = useChains();
  const chainId = useChainId();
  const { switchNetwork, switchNetworkLoading } = useCheckNetwork();

  const { showAccountPopup: show } = useSelector(selectGeneral);
  const handleClose = () => {
    dispatch(setShowNetworkPopup(false));
  };
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);

  const dispatch = useDispatch();
  const { authLoading } = useAuth();

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0  roboto-font z-50 ">
      <div
        ref={modalRef}
        className="w-11/12 md:w-[450px] flex flex-col items-center pb-5 pt-1 rounded-3xl bg-white "
      >
        <div className="w-full flex justify-end py-3 px-5">
          <button onClick={handleClose}>
            <MdClose className="" size={26} />
          </button>
        </div>

        {/* /////////////// */}

        {authLoading ? (
          <div className="w-full h-full flex justify-center items-center">
            <Oval
              height={30}
              width={30}
              color="#8538FF"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#8538FF"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />{" "}
          </div>
        ) : (
          <div className="w-full flex flex-col px-6 gap-2">
            {chains?.map((item, index) => (
              <NetworkItem
                key={index}
                data={item}
                currentChainId={chainId}
                switchNetwork={switchNetwork}
                switchNetworkLoading={switchNetworkLoading}
              />
            ))}
          </div>
        )}
        {/* /////////////// */}
      </div>
    </div>
  );
};

export default NetworkPopup;
